import React from "react";
import { Controller, Control } from "react-hook-form";

import { FormControlLabel } from "@mui/material";

import { Switch } from "@/components/form/switch/Switch";
import { ConditionalWrapper } from "@/shared/ConditionalWrapper";
import { ThemeProviderWithPrimaryPink } from "@/shared/ThemeProviderWithPrimaryPink";

type PropTypes = {
  label: string;
  name: string;
  control: Control;
  pinkVersion?: boolean;
};

export const LabelWithSwitch: React.FC<PropTypes> = ({
  label,
  control,
  name,
  pinkVersion = false,
}) => {
  return (
    <ConditionalWrapper
      on={pinkVersion}
      Wrapper={({ children }) => {
        return (
          <ThemeProviderWithPrimaryPink>
            {children}
          </ThemeProviderWithPrimaryPink>
        );
      }}
    >
      <div className="flex justify-between items-center">
        <Controller
          control={control}
          name={name}
          defaultValue={false}
          render={({ field: { onChange, value } }) => {
            return (
              <FormControlLabel
                value={value}
                onChange={onChange}
                labelPlacement="start"
                className="w-full flex justify-between ml-0"
                label={
                  <label
                    className="text-sm font-bold hover:cursor-pointer"
                    htmlFor={name}
                  >
                    {label}
                  </label>
                }
                control={<Switch checked={value} id={name} />}
              />
            );
          }}
        />
      </div>
    </ConditionalWrapper>
  );
};
